/**
 * Store Cleanup Hook
 * Sets up event listeners for cleaning stores on browser events
 */

import { useEffect } from "react"
import { setupStoreCleanup } from "@/stores"

/**
 * Hook to setup store cleanup event listeners
 * Should be used in the main app component or layout
 */
export const useStoreCleanup = () => {
	useEffect(() => {
		// Setup cleanup event listeners
		const cleanup = setupStoreCleanup()

		// Return the cleanup function to remove event listeners
		return cleanup
	}, [])
}
